export const SAMPLE_INJECTIONS_LIMIT = 50;
export const SEQUENCE_INJECTIONS_LIMIT = 200;
